import { render } from "./groupItem.vue?vue&type=template&id=56e6eb6c&scoped=true"
import script from "./groupItem.vue?vue&type=script&lang=js"
export * from "./groupItem.vue?vue&type=script&lang=js"

import "./groupItem.vue?vue&type=style&index=0&id=56e6eb6c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e6eb6c"]])

export default __exports__